import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import { WhatsAppChat } from "@/components/WhatsApp";
import { RoastBot } from "@/components/RoastBot";
import Home from "@/pages/Home";
import About from "@/pages/About";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Policy from "@/pages/Policy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <SmoothScroll />
          <Navbar />
          <CartDrawer />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/policies/:slug" element={<Policy />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppChat />
          <RoastBot />
          <Toaster
            position="top-center"
            toastOptions={{ style: { background: "#16052F", color: "#fff", border: "1px solid #CCFF00", fontFamily: "Plus Jakarta Sans" } }}
          />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
